import { observer } from "mobx-react";
import dashboardSettingsStore from "../../../../../stores/dashboard-settings-store";
import { PROFILE_CAPABILITIES } from "../../../../../models/ProfileCapabilities";
import PortalEdgeFontsAndColorsCard from "./portal-edge-fonts-and-colors-card";
import PortalClassicFontsAndColorsCard from "./portal-classic-fonts-and-colors-card";
import { useState } from "react";

const FontsAndColorsCard: React.FC = observer(() => {
    const portalCustomizations = dashboardSettingsStore.resolveCapability(
        PROFILE_CAPABILITIES.PORTAL_CUSTOMIZATIONS
    );
    const [isExpanded, setIsExpanded] = useState(false);

    if (portalCustomizations.isDualFontUiSupported) {
        return (
            <PortalEdgeFontsAndColorsCard
                isExpanded={isExpanded}
                onExpandedChange={setIsExpanded}
            />
        );
    }

    return (
        <PortalClassicFontsAndColorsCard
            isExpanded={isExpanded}
            onExpandedChange={setIsExpanded}
        />
    );
});

export default FontsAndColorsCard;
